import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, LazyMotion, MotionConfig, domMax } from 'motion/react';
import ToastProvider from './app/ToastProvider';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import EmailPage from './pages/EmailPage';
import RegistrationPage from './pages/RegistrationPage';
import RegistrationDonePage from './pages/RegistrationDonePage';

const HOME_PATHS = ['/', '/registration-done'];

const Root = () => {
  const location = useLocation();

  // /registration-done ma za pozadi HomePage, proto je ve stejne vetvi.
  const branch = HOME_PATHS.includes(location.pathname) ? 'home' : 'flow';

  return (
    <ToastProvider>
      {/* domMax misto domAnimation kvuli layoutId */}
      <LazyMotion features={domMax}>
        <MotionConfig reducedMotion="user">
          <AnimatePresence mode="wait">
            <Routes location={location} key={branch}>
              <Route path="/" element={<HomePage />} />
              <Route path="/registration-done" element={<RegistrationDonePage />} />

              <Route element={<Layout />}>
                <Route path="/verify-email" element={<EmailPage />} />
                <Route path="/register" element={<RegistrationPage />} />
              </Route>
            </Routes>
          </AnimatePresence>
        </MotionConfig>
      </LazyMotion>
    </ToastProvider>
  );
};

export default Root;
